module.exports = __webpack_public_path__ + "img/NachtragNew.7fb5af31.svg";